module.exports = __webpack_public_path__ + "74b61ce6bb6a06e50e9d34777eaa05a4.svg";